import {IncomingMessage} from 'http'
import {EQUITY_FROZEN_STATUS_CODE} from '@/constants/enum'
import {IGradeInfo, ISubjectInfo} from './common/requestBookInfo'
import request from '.'

export interface IBookDetail {
    bookId: SN;
    equityNumber: SN;
    bookName: string;
    overview: string;
    coverUrl: string;
    gradeList: IGradeInfo[];
    subjectInfo: ISubjectInfo;
    pClient: number;
    showProgress: true;
    progress: number;
    newTagLink: string;
    jumpScheme: string;
    // equityCodeStatus: EQUITY_CODE_CODE;
    claimStatus: EQUITY_FROZEN_STATUS_CODE;
}

export interface IBookListRes {
    bookDetailList: IBookDetail[];
    pager: IPagerRes;
    jumpClickMoreScheme: string;
}

/**
 * @description: 获取图书列表
 * @param pager: 分页
 */
export const requestBookList = (pager: IPagerReq, ctx?: CTX) => request<IBookListRes>({
    url: '/books/userBook/previewList',
    method: 'post',
    data: {pager},
    ctx,
})

/**
 * @description: 冻结确认
 * @param equityNumber: 权益id
 * @return bizType: app的code
 */
export const requestFreezeEquity = (equityNumber: SN) => request({
    url: '/books/frozenConfirm',
    method: 'post',
    data: {equityNumber},
})
